export default function PageJsonLd() {
  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Тренинг по переговорам для компаний',
    provider: {
      '@type': 'Person',
      name: 'Алексей Сивко',
      description: 'Бизнес-тренер с более чем 18-летним опытом в продажах и переговорах',
      url: 'https://sivko.by/',
    },
    description: 'Корпоративный тренинг по переговорам для руководителей, менеджеров и отделов продаж. Практическое обучение с диагностикой, реальными кейсами, сопровождением внедрения.',
    areaServed: ['Беларусь', 'Россия', 'Казахстан', 'Узбекистан', 'Израиль'],
    serviceType: 'Корпоративное обучение переговорам',
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/InStock',
      category: 'Корпоративный тренинг',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Что включает тренинг по переговорам?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Программа включает диагностику переговорной практики компании, интервью с участниками, адаптацию программы под специфику бизнеса, практический тренинг с переговорными поединками, разбор реальных кейсов, домашнюю практику и посттренинговое сопровождение. Каждый этап направлен на закрепление навыков и внедрение изменений.',
        },
      },
      {
        '@type': 'Question',
        name: 'Чем отличается обучение продажам от переговоров?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Продажи направлены на завершение сделки и получение заказа. Переговоры — более широкий навык: это управление решениями другой стороны, поиск взаимовыгодных решений, работа с интересами и долгосрочными отношениями. Переговоры включают продажи, но не ограничиваются ими — это коммуникация с закупщиками, партнёрами, подразделениями, руководителями.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли провести тренинг только для руководителей?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, мы проводим отдельные программы для руководителей высшего и среднего звена. В фокусе — стратегические переговоры, управление конфликтами, переговоры с партнёрами и ключевыми клиентами, межведомственные переговоры. Программа адаптируется под уровень участников и их реальные задачи.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли использовать реальные кейсы компании на тренинге?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, это обязательная часть программы. Мы разбираем реальные переговорные ситуации участников: сложные клиенты, тендеры, переговоры с закупщиками, внутренние конфликты. Это повышает вовлечённость и позволяет сразу применить полученные навыки на практике.',
        },
      },
      {
        '@type': 'Question',
        name: 'Как проходит сопровождение после тренинга по переговорам?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Сопровождение включает регулярные встречи, разбор сложных переговорных кейсов, поддержку в чате, корректировку стратегии переговоров, аудит проведённых встреч. Длительность — от 1 до 6 месяцев в зависимости от задач и выбранной программы.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли обучить закупщиков переговорам?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, у нас есть отдельные модули для отделов закупок. В программе: работа с поставщиками, тендерные переговоры, снижение закупочных цен без потери качества, построение долгосрочных отношений с контрагентами, управление конфликтами в цепочке поставок.',
        },
      },
      {
        '@type': 'Question',
        name: 'Работаете ли вы онлайн?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, тренинг по переговорам проводится в онлайн-формате с использованием интерактивных инструментов, переговорных поединков, разбора реальных кейсов и записи сессий. Онлайн-формат не уступает очному по эффективности при правильной организации.',
        },
      },
      {
        '@type': 'Question',
        name: 'Какие результаты обычно получают компании после тренинга по переговорам?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Результаты зависят от целей: рост конверсии переговоров на 18-55%, увеличение среднего чека, снижение скидок, рост продлений договоров (например, с 64% до 84% у Israel Assist), рост маржинальности сделок, сокращение цикла переговоров. Каждый проект имеет измеряемые KPI.',
        },
      },
      {
        '@type': 'Question',
        name: 'Как оценивается эффективность тренинга по переговорам?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Эффективность оценивается по конкретным показателям: рост конверсии встреч в сделки, изменение среднего чека, снижение процента скидок, рост количества долгосрочных контрактов, сокращение цикла переговоров. Мы фиксируем исходные показатели до тренинга и отслеживаем динамику после.',
        },
      },
      {
        '@type': 'Question',
        name: 'Сколько длится программа тренинга по переговорам?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Продолжительность зависит от формата: интенсив — 1-2 дня, модульное обучение — от 2 недель до 3 месяцев, комплексная программа с сопровождением — от 1 до 6 месяцев. Точная продолжительность определяется после диагностики и согласования целей.',
        },
      },
    ],
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Главная',
        item: { '@id': 'https://business-training.by/', name: 'Главная' },
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Продажи и переговоры',
        item: { '@id': 'https://business-training.by/prodazhi-i-peregovory/trening-po-prodazham', name: 'Продажи и переговоры' },
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: 'Тренинг по переговорам',
        item: { '@id': 'https://business-training.by/prodazhi-i-peregovory/trening-po-peregovoram', name: 'Тренинг по переговорам' },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
    </>
  );
}